<template>
    <InputMask
                mask="#### #### #### ####"
                :required="required"
                :label="label"
                :id="id"
                v-model="dataValue"></InputMask>
</template>

<script>
  import InputMask from './InputMask'
  export default {
      name: 'InputCCNumber',
      extends: InputMask,
      components: {
          InputMask
      },
      props: {
          mask: {
              type: String,
              default: ''
          }
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
          }
      },
      methods: {
      }
  }
</script>